module.exports = __webpack_public_path__ + "static/media/red.b005e11f.svg";